import type { HttpErrorResponse } from './types';

export class HttpError extends Error {
  public readonly status?: number | undefined;
  public readonly code?: string | undefined;
  public readonly details?: unknown;

  constructor(message: string, payload?: HttpErrorResponse) {
    super(message);
    this.name = 'HttpError';
    this.status = payload?.status;
    this.code = payload?.code;
    this.details = payload?.details;
  }
}

export class NetworkError extends HttpError {
  constructor(message = 'Network request failed', details?: unknown) {
    super(message, { details });
    this.name = 'NetworkError';
  }
}

export class TimeoutError extends HttpError {
  constructor(message = 'Request timed out', details?: unknown) {
    super(message, { details });
    this.name = 'TimeoutError';
  }
}

export class BadRequestError extends HttpError {
  constructor(message = 'Bad request', payload?: HttpErrorResponse) {
    super(message, payload);
    this.name = 'BadRequestError';
  }
}

export class UnauthorizedError extends HttpError {
  constructor(message = 'Unauthorized', payload?: HttpErrorResponse) {
    super(message, payload);
    this.name = 'UnauthorizedError';
  }
}

export class ForbiddenError extends HttpError {
  constructor(message = 'Forbidden', payload?: HttpErrorResponse) {
    super(message, payload);
    this.name = 'ForbiddenError';
  }
}

export class NotFoundError extends HttpError {
  constructor(message = 'Resource not found', payload?: HttpErrorResponse) {
    super(message, payload);
    this.name = 'NotFoundError';
  }
}

export class ValidationError extends HttpError {
  constructor(message = 'Validation failed', payload?: HttpErrorResponse) {
    super(message, payload);
    this.name = 'ValidationError';
  }
}

export class ServerError extends HttpError {
  constructor(message = 'Server error', payload?: HttpErrorResponse) {
    super(message, payload);
    this.name = 'ServerError';
  }
}
